import formSend from '@utils/form-send';

import '@utils/jquery/button-set-state';
import '@utils/jquery/disable-enter-submit';

const elements =
{
    showMore: ".c-poll__showResult",
    question: ".c-poll__question",
    result: ".c-poll__result",
    container: ".c-poll",
    back: ".c-poll__back",
    form: ".c-poll__form",
    errors: ".c-poll__errors",
    count: ".c-poll__votingCount",
    submit: ".c-poll__submit"
};

function successCallback(data)
{
    const { survey } = data;
    $(elements.container).addClass('c-poll__voted');
    $(elements.errors).addClass('fn-hidden').html('');
    const form = $(elements.form);
    survey.options.forEach((question) => {
        const fieldset = $(elements.container).find(elements.result).find(`[data-option-id='${question.id}']`);
        fieldset.find('h4').html(`${question.percentage}%`);
        fieldset.find('figcaption').attr('style', `width: ${question.percentage}%`);
    });
    $(elements.count).html(survey.votesCount);
}

function failCallback(data)
{
    const { errors } = data;
    if (errors.general) {
        $(elements.errors).removeClass('fn-hidden').html(errors.general);
    } else {
        throw errors;
    }
}

function sendHandler($button)
{
    const $form = $button.parents('form');

    formSend
    (
        {
            form: $form,
            callbacks:
            {
                before: () => {
                    $button.buttonSetState('inProgress');
                },
                done: (response) => {
                    if (response.status === 'ok') {
                        successCallback(response.data);
                    } else if (response.status === 'error') {
                        failCallback(response.data);
                    }
                },
                always: () => {
                    $button.buttonSetState('backDefault');
                }
            }
        }
    );
}

function init()
{
    const container = $(elements.container);

    $(elements.showMore).on('click', (event) => {
        event.preventDefault();
        container.addClass('c-poll__showResult');
    });

    $(elements.back).on('click', (event) => {
        container.removeClass('c-poll__showResult');
        $(elements.errors).html('').addClass('fn-hidden');
    });

    $(elements.submit).on('click', function(event) {
        event.preventDefault();

        const $button = $(this);
        sendHandler($button);
    });
}

export default { init }



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/poll/index.js